// Shared by the search API, the query layer and the header overlay. Kept in
// constants rather than in `@/lib/queries` so the client bundle never has to
// import the module that pulls in the Postgres driver.
export const SEARCH_MIN_LENGTH = 2
export const SEARCH_DEBOUNCE_MS = 180
export const SEARCH_MAX_TERM_LENGTH = 80
